﻿import { AlertTriangle, Clock, DollarSign } from "lucide-react";
import type { InventoryItem } from "@/hooks/inventory/useInventoryData";
import type { StockRequest } from "@/hooks/inventory/useInventoryData";
import {
  
  } from "@/hooks/inventory/useInventoryData";

export function InventoryMetrics({
  inventory,
  requests,
}: {
  inventory: InventoryItem[];
  requests: StockRequest[];
}) {
  const totalValue = inventory.reduce(
    (acc, curr) => acc + curr.qty * Number(curr.cost_price),
    0,
  );
  const lowStockItems = inventory.filter((i) => i.qty <= i.min_qty);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="bg-slate-900/50 backdrop-blur-md border border-slate-800 p-5 rounded-2xl flex items-center gap-4">
        <div className="p-3 bg-emerald-500/10 rounded-xl">
          <DollarSign className="text-emerald-500" size={24} />
        </div>
        <div>
          <p className="text-slate-400 text-sm font-medium">
            Capital Imobilizado
          </p>
          <p className="text-2xl font-bold text-white">
            R$ {totalValue.toFixed(2)}
          </p>
        </div>
      </div>

      <div
        className={`bg-slate-900/50 backdrop-blur-md border border-slate-800 p-5 rounded-2xl flex items-center gap-4 ${
          lowStockItems.length > 0 ? "ring-1 ring-red-500/50" : ""
        }`}
      >
        <div
          className={`p-3 rounded-xl ${lowStockItems.length > 0 ? "bg-red-500/10" : "bg-slate-800"}`}
        >
          <AlertTriangle
            className={
              lowStockItems.length > 0 ? "text-red-500" : "text-slate-500"
            }
            size={24}
          />
        </div>
        <div>
          <p className="text-slate-400 text-sm font-medium">Estoque Baixo</p>
          <p
            className={`text-2xl font-bold ${
              lowStockItems.length > 0 ? "text-red-400" : "text-white"
            }`}
          >
            {lowStockItems.length}{" "}
            {lowStockItems.length === 1 ? "item" : "itens"}
          </p>
        </div>
      </div>

      <div
        className={`bg-slate-900/50 backdrop-blur-md border border-slate-800 p-5 rounded-2xl flex items-center gap-4 ${
          requests.length > 0 ? "ring-1 ring-amber-500/50" : ""
        }`}
      >
        <div
          className={`p-3 rounded-xl ${requests.length > 0 ? "bg-amber-500/10" : "bg-slate-800"}`}
        >
          <Clock
            className={
              requests.length > 0 ? "text-amber-500" : "text-slate-500"
            }
            size={24}
          />
        </div>
        <div>
          <p className="text-slate-400 text-sm font-medium">
            Pedidos Pendentes
          </p>
          <p
            className={`text-2xl font-bold ${
              requests.length > 0 ? "text-amber-400" : "text-white"
            }`}
          >
            {requests.length} aguardando
          </p>
        </div>
      </div>
    </div>
  );
}
